import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7301Model } from '../kymw7301.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW00Model } from 'src/app/commons/kymw00/kymw00.model';

/**
 * 注文単位値引クーポン情報更新サービス
 *
 * @export UpdateCouponService
 * @class UpdateCouponService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCouponService extends PlessJsonResponderSub<null> {
  private model: KYMW7301Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCouponService
   */
  private getBody(): PlessRequest {
    const coopCodeList = this.model.coopCodeList.map(_ => ({
      parameter: {
        CoopCode: _,
      },
    }));
    return new PlessRequest({
      update: {
        UpdateOrderunitDiscountCoupon: {
          condition: {
            CouponGoodsNo: this.model.couponGoodsNo,
          },
          parameter: {
            CouponCategory: this.model.couponCategory,
            CouponOrderCd: this.model.couponOrderCd,
            NoticeExistenceType: this.model.noticeExistenceType,
            NoticeMethodTypeItem: this.model.noticeMethodTypeItem,
            NoticeMethodTypeMail: this.model.noticeMethodTypeMail,
            UseStandardPrice: this.model.useStandardPrice,
            StartMemberWeek: this.model.startMemberWeek,
            EndMemberWeek: this.model.endMemberWeek,
            CouponIssueCatalogStart: this.model.couponIssueCatalogStart,
            CouponIssueCatalogEnd: this.model.couponIssueCatalogEnd,
            ValidWeek: this.model.validWeek,
            CouponReceiptCatalogStart: this.model.couponReceiptCatalogStart,
            CouponReceiptCatalogEnd: this.model.couponReceiptCatalogEnd,
            DiscountPrice: this.model.discountPrice,
            CouponName: this.kymw00Model.deleteStartAndEndSpace(this.model.couponName),
            CouponNameKana: this.kymw00Model.deleteStartAndEndSpace(this.model.couponNameKana),
            EcTitle: this.kymw00Model.deleteStartAndEndSpace(this.model.ecTitle),
            DetailsTitle: this.kymw00Model.deleteStartAndEndSpace(this.model.detailsTitle),
            UseTerms: this.model.useTerms,
            DiscountedAmount: this.model.discountedAmount,
            ValidatedDate: this.model.validatedDate,
            CpgrpCd: this.model.cpgrpCd,
            CouponCategoryChangeFlg: this.model.couponCategoryChangeFlg,
            ChangeOtherCatalogEndFlg: this.model.changeOtherCatalogEndFlg,
          },
          combination: coopCodeList,
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof UpdateCouponService
   */
  execute(model: KYMW7301Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('updateCoupon', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof UpdateCouponService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
